module.exports = __webpack_public_path__ + "static/media/purdue.e547a9bd.jpeg";